import { EventDispatcher } from "../../../core/internal/event/EventDispatcher"
import { EventDto } from "../../../core/internal/event/dto"
import UserEvent from "../../../core/internal/event/UserEvent"
import { EventRetryManager } from "../../../core/internal/event/EventRetryManager"
import { EventTransport } from "../../../core/internal/event/EventTransport"

export class BrowserEventDispatcher implements EventDispatcher {
  constructor(
    private readonly transport: EventTransport,
    private readonly synchronousTransport: EventTransport, // maybe beacon
    private readonly retryManager: EventRetryManager
  ) {}

  dispatch(events: UserEvent[], sync: boolean): Promise<void> {
    const dto = events.map((it) => it.toDto())
    if (sync) {
      return this.dispatchEventsSynchronously(dto)
    }
    return this.dispatchEvents(dto)
  }

  private async dispatchEventsSynchronously(events: EventDto[]): Promise<void> {
    // add to retry manager first in case of fast close
    await this.retryManager.add(events)
    const response = await this.synchronousTransport.send(events)
    if (response.isSuccessful() || response.isClientError()) {
      await this.retryManager.delete(events)
    }
  }

  private async dispatchEvents(events: EventDto[]): Promise<void> {
    const response = await this.transport.send(events)
    if (response.isSuccessful() || response.isClientError()) {
      return
    }

    await this.retryManager.add(events)
  }
}
